import _message from "antd/es/message";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import SLSymbolIcon from '../OneSymbolIcon';
import cs from 'classnames';
import './index.less';
var OneMessage = _objectSpread(_objectSpread({}, _message), {}, {
  success: function success(content, duration, onClose) {
    var contentConfig = {
      content: content ? content : /*#__PURE__*/React.createElement(React.Fragment, null),
      type: 'success',
      icon: /*#__PURE__*/React.createElement(SLSymbolIcon, {
        style: {
          marginRight: 8,
          fontSize: 16
        },
        className: "icon-success",
        icon: "icon-iconCheckCircle"
      }),
      duration: typeof duration === 'number' ? duration : 3,
      className: 'one-message-success',
      onClose: onClose
    };
    if (Object.prototype.toString.call(content) === '[object Object]') {
      contentConfig.content = content === null || content === void 0 ? void 0 : content.content;
      contentConfig = _objectSpread(_objectSpread(_objectSpread({}, contentConfig), content), {}, {
        className: cs(contentConfig.className, content === null || content === void 0 ? void 0 : content.className)
      });
    }
    _message.success(contentConfig, duration, onClose);
  },
  error: function error(content, duration, onClose) {
    var contentConfig = {
      content: content ? content : /*#__PURE__*/React.createElement(React.Fragment, null),
      type: 'error',
      icon: /*#__PURE__*/React.createElement(SLSymbolIcon, {
        style: {
          marginRight: 8,
          fontSize: 16
        },
        className: "icon-error",
        icon: "icon-iconCloseCircle"
      }),
      duration: typeof duration === 'number' ? duration : 3,
      className: 'one-message-error',
      onClose: onClose
    };
    if (Object.prototype.toString.call(content) === '[object Object]') {
      contentConfig.content = content === null || content === void 0 ? void 0 : content.content;
      contentConfig = _objectSpread(_objectSpread(_objectSpread({}, contentConfig), content), {}, {
        className: cs(contentConfig.className, content === null || content === void 0 ? void 0 : content.className)
      });
    }
    _message.error(contentConfig, duration, onClose);
  },
  info: function info(content, duration, onClose) {
    var contentConfig = {
      content: content ? content : /*#__PURE__*/React.createElement(React.Fragment, null),
      type: 'info',
      icon: /*#__PURE__*/React.createElement(SLSymbolIcon, {
        style: {
          marginRight: 8,
          fontSize: 16
        },
        className: "icon-info",
        icon: "icon-iconExclamationCircle"
      }),
      duration: typeof duration === 'number' ? duration : 3,
      className: 'one-message-info',
      onClose: onClose
    };
    if (Object.prototype.toString.call(content) === '[object Object]') {
      contentConfig.content = content === null || content === void 0 ? void 0 : content.content;
      contentConfig = _objectSpread(_objectSpread(_objectSpread({}, contentConfig), content), {}, {
        className: cs(contentConfig.className, content === null || content === void 0 ? void 0 : content.className)
      });
    }
    _message.info(contentConfig, duration, onClose);
  }
});
export default OneMessage;